import React from 'react';
import { RouterContext } from './router-context';
export const RouterProvider = ({ children, navigate }) => {
    const router = React.useMemo(() => ({ navigate }), [navigate]);
    return React.createElement(RouterContext.Provider, { value: router }, children);
};
